import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-patternnotime",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,

    types: ["Number"],
  },

  dataFetching: {
    history: true,
    historyRequired: true,
  },

  presets: [
    {
      label: "Prozessübersicht",
      description: "highcharts:explorer.timepattern.description",
      layout: [6, 6],
      tags: ["charttime"],
      imageLink: async () => (await import("../hc-pattern/res_line")).default,
      widget: {
        config: {
          type: "spline",
          aggregationGroup: "hourOfDay",
          aggregationOperation: "mean",
        },
      },
    },
  ],
});
